import { render, staticRenderFns } from "./RegisterNewAccountEntryView.vue?vue&type=template&id=4133b1ea&scoped=true&"
import script from "./RegisterNewAccountEntryView.vue?vue&type=script&lang=ts&"
export * from "./RegisterNewAccountEntryView.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterNewAccountEntryView.vue?vue&type=style&index=0&id=4133b1ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133b1ea",
  null
  
)

export default component.exports